import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserActivityActions = createActionGroup({
  source: 'User Activity',
  events: {
    'Activity Restored': props<{ idleSeconds: number }>(),
    /** Inactivity reload prompt was shown. hoursInactive = total inactivity (1-decimal) when it opened. */
    'Inactivity Reload Prompt Opened': props<{ hoursInactive: number }>(),
    /** Inactivity reload prompt was closed. shouldReload = true when the user chose Reload. */
    'Inactivity Reload Prompt Closed': props<{ hoursInactive: number; shouldReload: boolean }>(),
    'Check for App Updates': emptyProps(),
    'New Version Prompt Opened': props<{ version: string | null }>(),
    'New Version Prompt Closed': props<{ version: string; shouldReload: boolean }>(),
  },
});
